module.exports = __webpack_public_path__ + "static/media/badge-web-app.583b5ab1.png";